import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const DeletedMessageWrapper = styled.div `
  color: #696969;
  padding: 10px 15px;
  font-style: italic;
  max-width: 80%; /* Maximum width of the message */
  word-wrap: break-word;
  font-size: 14px;
`;
const DeletedMessage = () => (_jsx(DeletedMessageWrapper, { children: "This message has been deleted." }));
export default DeletedMessage;
